module.exports = "/assets/data/a4e4e82e4682260899a1c3390a7dae4a-BN2.data.json";